<div *ngIf="form" [formGroup]="form">

  <!-- Pretraga stornirane fakture -->
  <div class="p-mt-5">
    <kodit-card-container>
      <div card-title>Ulazni račun</div>
      <div card-body class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
        <kodit-field
          fieldLabel="Broj fakture"
          fieldLabelFor="racun-search"
          class="flex-50"
        >
          <p-autoComplete
            [(ngModel)]="racunSearchValue"
            [ngModelOptions]="{ standalone: true }"
            [suggestions]="racunSuggestions"
            [field]="'broj'"
            (completeMethod)="handleRacunSearch($event)"
            (onSelect)="handleRacunSelect($event)"
            (onClear)="handleRacunClear()"
            (onKeyUp)="onRacunInputKeyUp()"
            placeholder="Unesite broj računa..."
            appendTo="body"
            styleClass="w-full"
          >
            <ng-template let-racun pTemplate="item">
              <div>
                <span class="p-d-block">{{ racun.intorniBroj }}<ng-container *ngIf="racun.broj && racun.broj !== racun.intorniBroj"> - {{ racun.broj }}</ng-container></span>
                <small class="p-text-secondary">{{ racun.nazivStranke }}</small>
              </div>
            </ng-template>
          </p-autoComplete>
        </kodit-field>

        <div class="flex-50"></div>
      </div>
    </kodit-card-container>
  </div>

  <!-- Primalac -->
  <div class="p-mt-5">
    <kodit-card-container>
      <div card-title>Primalac</div>
      <div card-body class="p-d-flex p-flex-column">
        <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
          <kodit-field fieldLabel="PIB primaoca *" fieldLabelFor="pib-primaoca" class="flex-50">
            <kodit-text-input [formCtrl]="form.controls.pibPrimaoca"></kodit-text-input>
          </kodit-field>
          <kodit-field fieldLabel="Matični broj / JBKJS primaoca" fieldLabelFor="mb-primaoca" class="flex-50">
            <kodit-text-input [formCtrl]="form.controls.mbPrimaoca"></kodit-text-input>
          </kodit-field>
        </div>
      </div>
    </kodit-card-container>
  </div>

  <!-- Obaveštenje -->
  <div class="p-mt-5">
    <kodit-card-container>
      <div card-title>Obaveštenje</div>
      <div card-body class="p-d-flex p-flex-column">

        <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
          <kodit-field fieldLabel="Broj obaveštenja *" fieldLabelFor="broj-obavestenja" class="flex-50">
            <kodit-text-input [formCtrl]="form.controls.brojObavestenja"></kodit-text-input>
          </kodit-field>
          <kodit-field fieldLabel="Ukupan iznos PDV *" fieldLabelFor="ukupan-iznos-pdv" class="flex-50">
            <kodit-number-input
              formCtrlId="ukupan-iznos-pdv"
              [formCtrl]="form.controls.ukupanIznosPdv"
              [ctrlMinValue]="0.01"
            ></kodit-number-input>
          </kodit-field>
        </div>

        <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
          <kodit-field fieldLabel="Poreklo dokumenta *" fieldLabelFor="poreklo-dokumenta" class="flex-50">
            <p-dropdown
              formControlName="porekeloDokumenta"
              [options]="porekeloDokumentaOptions"
              placeholder="Izaberite..."
              appendTo="body"
            ></p-dropdown>
            <kodit-error-info-required [formCtrl]="form.controls.porekeloDokumenta"></kodit-error-info-required>
          </kodit-field>
          <kodit-field fieldLabel="Osnov obaveštenja *" fieldLabelFor="osnov-obavestenja" class="flex-50">
            <p-dropdown
              formControlName="osnovObavestenja"
              [options]="osnovObavestenjaOptions"
              placeholder="Izaberite..."
              appendTo="body"
            ></p-dropdown>
            <kodit-error-info-required [formCtrl]="form.controls.osnovObavestenja"></kodit-error-info-required>
          </kodit-field>
        </div>

      </div>
    </kodit-card-container>
  </div>

  <!-- Referentni dokument -->
  <div class="p-mt-5">
    <kodit-card-container>
      <div card-title>Referentni dokument</div>
      <div card-body class="p-d-flex p-flex-column">

        <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
          <kodit-field fieldLabel="Tip referentnog dokumenta *" fieldLabelFor="tip-ref-dokumenta" class="flex-50">
            <p-dropdown
              formControlName="tipReferentnogDokumenta"
              [options]="tipReferentnogDokumentaOptions"
              placeholder="Izaberite..."
              appendTo="body"
            ></p-dropdown>
            <kodit-error-info-required [formCtrl]="form.controls.tipReferentnogDokumenta"></kodit-error-info-required>
          </kodit-field>
          <kodit-field fieldLabel="Broj referentnog dokumenta *" fieldLabelFor="broj-ref-dokumenta" class="flex-50">
            <kodit-text-input [formCtrl]="form.controls.brojReferentnogDokumenta"></kodit-text-input>
          </kodit-field>
        </div>

        <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
          <kodit-field fieldLabel="Datum referentnog dokumenta *" fieldLabelFor="datum-ref-dokumenta" class="flex-50">
            <kodit-calendar
              formCtrlId="datum-ref-dokumenta"
              [formCtrl]="form.controls.datumReferentnogDokumenta"
            ></kodit-calendar>
          </kodit-field>

          <ng-container *ngIf="jeStornoOsnov">
            <kodit-field fieldLabel="Datum storniranja referentnog dokumenta *" fieldLabelFor="datum-storno" class="flex-50">
              <kodit-calendar
                formCtrlId="datum-storno"
                [formCtrl]="form.controls.datumStornoReferentnogDokumenta"
              ></kodit-calendar>
            </kodit-field>
          </ng-container>

          <div *ngIf="!jeStornoOsnov" class="flex-50"></div>
        </div>

        <ng-container *ngIf="jePeriodTip">
          <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
            <kodit-field fieldLabel="Period od *" fieldLabelFor="pocetak-perioda" class="flex-50">
              <kodit-calendar
                formCtrlId="pocetak-perioda"
                [formCtrl]="form.controls.pocetakPeriodaFakture"
              ></kodit-calendar>
            </kodit-field>
            <kodit-field fieldLabel="Period do *" fieldLabelFor="kraj-perioda" class="flex-50">
              <kodit-calendar
                formCtrlId="kraj-perioda"
                [formCtrl]="form.controls.krajPeriodaFakture"
              ></kodit-calendar>
            </kodit-field>
          </div>
        </ng-container>

      </div>
    </kodit-card-container>
  </div>

  <!-- Napomena -->
  <div class="p-mt-5">
    <kodit-card-container>
      <div card-title>Napomena</div>
      <div card-body class="p-fluid">
        <kodit-field fieldLabelFor="dodatna-napomena" fieldLabel="Dodatna napomena">
          <textarea
            id="dodatna-napomena"
            rows="5"
            pInputText
            autoResize="autoResize"
            [formControl]="form.controls.napomena!"
          ></textarea>
          <kodit-error-info-max-length
            [formCtrl]="form.controls.napomena"
          ></kodit-error-info-max-length>
        </kodit-field>
      </div>
    </kodit-card-container>
  </div>

  <!-- Footer -->
  <div class="p-mt-5" card style="position: sticky; bottom: 0; z-index: 9">
    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-between">
      <div class="dodatne-akcije p-d-flex p-flex-column p-jc-around p-ml-3"></div>
      <div class="primarne-akcije p-as-center p-d-flex gap-6">
        <button
          pButton
          pRipple
          icon="far fa-window-close"
          type="button"
          label="Otkaži"
          class="p-button-secondary p-button-outlined"
          (click)="handleCancel()"
        ></button>
        <button
          pButton
          icon="fas fa-paper-plane"
          type="button"
          label="Pošalji obaveštenje"
          class="p-button-success"
          (click)="handleSave()"
        ></button>
      </div>
    </div>
  </div>

</div>
